(ns pfo.common.model
  (:require [goog.string :refer [endsWith]]
            [cljs-time.core :as time-core]
            [pfo.time :as time :refer [is-now-within-window]]
            [pfo.form :refer [month-choices]]
            [pfo.util :as util]))

(def deletion-prevention-allow-max-age (time-core/minutes js/DELETE_PREVENTION_MAX_MINUTES))

(defn document-complex-name 
  ([doc]
   (let [cname (:complex_name doc)
         aname (:name doc)]
     (if (and (not-empty aname) (endsWith cname aname))
       [:span (subs cname 0 (- (count cname) (count aname))) [:em aname]]
       [:span cname])))

  ([doc raw?]
   (let [cname (:complex_name doc)
         aname (:name doc)]
     (if (and (not-empty aname) (endsWith cname aname))
       (str (subs cname 0 (- (count cname) (count aname))) aname )
       (str cname)))))


(defn document-complex-name-build [{:keys [day
                                           year
                                           month
                                           quarter
                                           category_name
                                           document_name]}]
  (let [date (if (and month (pos? month))
               (let [month-name (subs ((into {} month-choices) month) 0 3)]
                 [year month-name day])
               [year (when (and quarter (pos? quarter)) (str "Q" quarter))])]
    (filter identity
      (flatten [category_name date document_name]))))

(defn with-complex-names [documents]
  (mapv #(assoc % :complex_name (document-complex-name %)) documents))

(defn is-within-delete-prevention-allow-window [creation-time-str]
  (is-now-within-window (util/parse-datetime creation-time-str) deletion-prevention-allow-max-age))

(defn has-delete-prevention? [obj] (get-in obj [:perms :deletion_prevention]))

(defn delete-prevention-delete-ability
  ([iatom obj creation-time-key]
   (if (has-delete-prevention? obj)
     (util/self-updating-atom
       iatom
       (fn [] (when (is-within-delete-prevention-allow-window (creation-time-key obj))
                :delete-with-timer)))
     (do (reset! iatom :delete)
         iatom)))
  ([iatom obj] (delete-prevention-delete-ability iatom obj :created_at)))
